const removePunctuation = (str: string) => str.replace(/[.;:',_-]*/g, "");

export const simplifyScript = (script: string) => removePunctuation(script);
